var service = function() {
  var prepareSample = function(sample) {
    return _.map(sample, function(s) {
      return s.product_line.name;
    }).join(', ').slice(0, 64) + '...';
  };

  return {
    prepareSample: prepareSample
  };
};

service.$inject = [];

tiz.service('QuickOrderList', service);
